import { AxiosRequestConfig } from "axios";
import environment from "../misc/environment";

export function NinoxRequestInterceptor(request: AxiosRequestConfig) {
	const apiKey = environment.REACT_APP_NINOX_API_KEY;
	const bearerToken = "Bearer " + apiKey;
	request.headers = { ...request.headers, Authorization: bearerToken };
	return request;
}
